import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {Box, Text, useStyleConfig} from '@chakra-ui/react'
import YoutubeIframe from '../../../youtube-video'
import useDamImage from '../../../../custom-hooks/use-dam-image'

const PromoVideoSliderCard = ({label, title, source, thumbnail, isActive}) => {
    const styles = useStyleConfig('PromoSlider')
    const [interacting, setInteracting] = useState(false)

    const pdpThumbnailUrl = thumbnail?.url
    const {url: damThumbnailUrl} = useDamImage(thumbnail)
    const thumbnailUrl = pdpThumbnailUrl || damThumbnailUrl

    const handleInteractionStart = () => {
        setInteracting(true) // Set interacting to true when the video is clicked
    }

    const handleInteractionEnd = () => {
        // Ensure interacting is reset immediately after pause
        setInteracting(false)
    }

    return (
        <Box
            {...styles.promoSliderVideoContainer}
            position="relative"
            data-testid="promo-slide-video-container"
        >
            {source?.href && (
                <YoutubeIframe
                    videoSrc={source.href}
                    title={source?.title}
                    height="100%"
                    thumbnail={thumbnailUrl}
                    onPause={handleInteractionEnd} // Reset interaction on pause
                    enableInteractionHandlers={true}
                    key={isActive}
                />
            )}

            <Box
                position="absolute"
                top="0"
                left="0"
                right="0"
                bottom="0"
                zIndex="10"
                bg="transparent"
                pointerEvents={interacting ? 'none' : 'auto'} // Allow interaction with the video when interacting
                onClick={handleInteractionStart} // Set interacting to true on click
            />

            <Box {...styles.contentOverlay} data-testid="promo-slide-video-content">
                {label && <Text {...styles.label}>{label}</Text>}
                {title && <Text {...styles.title}>{title}</Text>}
            </Box>
        </Box>
    )
}

PromoVideoSliderCard.propTypes = {
    label: PropTypes.string,
    title: PropTypes.string,
    source: PropTypes.shape({title: PropTypes.string, href: PropTypes.string}),
    thumbnail: PropTypes.object,
    isActive: PropTypes.bool,
}
export default PromoVideoSliderCard
